import { useEffect, useState } from "react";
import { Mint } from "../../generated/graphql";
import { ChevronsUpDown } from "lucide-react";
import { Button } from "./button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

interface MintSelectProps {
  mintOptions?: Mint[];
  onSelect?: (mint: Mint | null) => void;
  selectedMint?: Mint | null;
}

export function MintSelect({
  mintOptions,
  onSelect,
  selectedMint,
}: MintSelectProps) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(selectedMint?.name || "");

  useEffect(() => {
    setValue(selectedMint?.name || "");
  }, [selectedMint]);

  if (!mintOptions) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[250px] justify-between"
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {value ? (
              <>
                {selectedMint?.img && (
                  <img
                    src={selectedMint.img}
                    className="mr-2 h-4 w-4"
                    alt={value}
                  />
                )}
                {value}
              </>
            ) : (
              "Select Coin..."
            )}
          </div>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[250px] p-0">
        <Command style={{ pointerEvents: "auto" }}>
          <div style={{ pointerEvents: "auto" }}>
            <CommandInput placeholder="Search supported coins..." />
            <CommandList>
              <CommandEmpty>No coin found...</CommandEmpty>
              <CommandGroup>
                {mintOptions.map((mint) => (
                  <CommandItem
                    key={mint.id}
                    value={mint.name}
                    onSelect={(currentValue: string) => {
                      setValue(currentValue === value ? "" : currentValue);
                      onSelect?.(mint);
                      setOpen(false);
                    }}
                  >
                    {mint.img && (
                      <img
                        src={mint.img}
                        className="mr-2 h-4 w-4"
                        alt={mint.name}
                      />
                    )}
                    {mint.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </div>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
